import { useContext } from "preact/hooks"
import assets, { getDay } from "../assets"
import { AgendaSidebar } from "../components/AgendaSidebar"
import { auditoriumAgenda } from "../data/agendas"
import { CongressBackInTime } from "./onDemand"
import { DayContext } from "../contexts/DayContext"
import SessionTracker from "../components/SessionTracker"
import { achievement } from "../utils"


export const generateAuditoriums = (onDemand = false) => {
	const { backup } = useContext(DayContext)
	const { auditorium } = assets
	const day = getDay()

	const [hall, ...rooms] = !onDemand ? auditorium.df : auditorium.od
	const foyerDoors = !onDemand ? auditorium.foyer_doors.df : auditorium.foyer_doors.od

	return [
		{
			background: hall,
			links: [
				CongressBackInTime,
				{
					height: "33.2%",
					href: foyerDoors[2][1],
					label: foyerDoors[2][0],
					left: "83.5%",
					top: "38.6%",
					width: "13.9%",
				},
				...(foyerDoors[1] ? [{
					height: "33.2%",
					href: foyerDoors[1][1],
					label: foyerDoors[1][0],
					left: "43%",
					top: "31.6%",
					width: "13.9%",
				}] : []),
				{
					height: "33.2%",
					href: foyerDoors[0][1],
					label: foyerDoors[0][0],
					left: "3%",
					top: "38.6%",
					width: "13.9%",
				}
			],
			showNavbar: false,
			name: "auditorium-foyer"
		},
		...rooms.map((r, idx) => {
			const name = `auditorium-${auditorium.append[idx] || idx + 1}`
			return {
				background: r,
				extras: (
					<>
						<div style={{
							top: "3%",
							right: "1.3%",
							position: "absolute",
							width: "16.2%",
							height: "83.8%"
						}}>
							<h2 style={{textAlign: "center", marginTop: ".4em"}}>Today&apos;s Agenda</h2>
							<AgendaSidebar agendas={auditoriumAgenda} room={name} startField="startDate" endField="endDate"/>
							<SessionTracker agenda={auditoriumAgenda.filter(it => it.room === name)} triggerAt={15} onComplete={(isKeynote) => {
								achievement(isKeynote ? "54bd756f-9a8a-4689-9e37-3dd3ab8a615e" : "16ff515d-9e1f-4e84-92e8-a8a833a6e7b4")
							}} />
						</div>
						<iframe className="auditorium-livestream" src={backup.using ? auditorium.streamingbkp[idx] : auditorium.streaming[idx]} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
					</>
				),
				links: [
					{
						height: "7.2%",
						href: "/",
						label: "Back to Atrium",
						left: "27.3%",
						top: "88.9%",
						width: "13%",
					},
					{
						height: "7.2%",
						// href: auditorium.QA[idx],
						label: "Feedback",
						onClick() {
							window.open(auditorium.QA[idx])
							const now = new Date()
							const session = auditoriumAgenda.find(it => {
								return it.room === name && new Date(it.startDate) <= now
							})

							
							if (!session) return;
							if (localStorage.getItem(`feedback_${session.title}`) === null) {
								achievement(assets.global.feedback)
								localStorage.setItem(`feedback_${session.title}`, "true")
							}

						},
						// target: "_blank",
						// isExternal: true,
						left: "43.5%",
						top: "88.9%",
						width: "13%",
					},
					{
						height: "7.2%",
						label: "Slido/Q&A Polls",
						left: "59.7%",
						top: "88.9%",
						width: "13%",
						modalOverrides: {
							dismissHTML: "X",
							backdropStyle: {
								justifyContent: "flex-end",
								alignItems: "stretch"
							},
							style: {
								borderRadius: 0
							}
						},
						modal: <>
							<iframe src={auditorium.slido[idx]} style={{
								marginTop: "20px",
								width: "100%",
								height: "100%",
								border: 0,
								borderRadius: "16px"
							}}/>
						</>
					},
				],
				name: name,
				navName: `Auditorium ${idx + 1}`,
				showNavbar: day < 3,
			}
		})
	]
}